<template>
  <nav :key="updateKey">
    <ul>
      <li v-for="item in list" :key="item.id">
        <template v-if="item.children && item.children.length">
          <el-dropdown placement="top-start" @command="handleHowToPlay" v-if="!isMobile">
            <span class="el-dropdown-link">
              <router-link class="nav-link" v-if="item.type == 'how-to-play'"
                :class="[$route.path != '/home' && $route.path != '/weapon-cases' ? 'active' : '']"
                :to="{ path: '/home' + item.url }">
                {{ item.name }}
              </router-link>
              <router-link class="nav-link" v-else
                :class="[$route.path == item.url || $route.path == '/weapon-cases' ? 'active' : '']"
                :to="{ path: '/home' + item.url }">
                {{ item.name }}
              </router-link>
            </span>
            <el-dropdown-menu class="custom-dropdown-nav" slot="dropdown">
              <el-dropdown-item :command="{ type: item.type, value: nav.value, target: nav.target || '' }"
                v-for="nav in item.children" :key="item.value">{{ nav.label }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- mobile -->
          <div class="custom-dropdown" v-else>
            <div class="dropdown-link">
              <router-link class="nav-link"
                :class="[($route.hash == item.url) && ($route.path == '/home') ? 'active' : '']"
                :to="{ path: '/home' + (item.url == '#home' ? '' : item.url) }" @click.native="handleHomeBtnLink(item)"
                v-if="!isExternal(item.url)">
                <span>{{ item.name }}</span>
              </router-link>
              <i class="el-icon-arrow-down" @click="showDropdownMenu(item.type)"></i>
            </div>
            <div class="dropdown-menu" :id="`menu-${item.type}`">
              <div class="menu-item" v-for="nav in item.children" :key="item.value"
                @click="handleHowToPlay({ type: item.type, value: nav.value, target: nav.target || '' })">
                {{ nav.label }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <router-link class="nav-link" :class="[($route.hash == item.url) && ($route.path == '/home') ? 'active' : '']"
            :to="{ path: '/home' + (item.url == '#home' ? '' : item.url) }" @click.native="handleHomeBtnLink(item)"
            v-if="!isExternal(item.url)">
            {{ item.name }}
          </router-link>
          <a :href="item.url" target="_blank" v-else>{{ item.name }}</a>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
import { isExternal } from "@/libs/validate";
import { playStep, gameOverview } from "@/utils/dict";
import responsiveMixin from "@/mixins/responsive";
import Bus from "@/libs/bus";

export default {
  name: "",
  mixins: [responsiveMixin],
  data() {
    return {
      updateKey: 0,
      isExternal,
      list: [
        {
          id: "1",
          name: "Home",
          type: "home",
          url: "#home"
        },
        {
          id: "2",
          name: "How To Play",
          type: "how-to-play",
          url: "#howToPlay",
          children: [
            {
              label: "Overview",
              value: "/how-to-play"
            },
            ...playStep
          ]
        },
        {
          id: "3",
          name: "News",
          type: "news",
          url: "#news"
        },
        {
          id: "4",
          name: "Game Overview",
          type: "game-overview",
          url: "#game-modes",
          children: gameOverview
        },
        {
          id: "5",
          name: "Matr1x Platform",
          url: "https://matr1x.io/platform"
        }
      ]
    }
  },
  props: {},
  components: {},
  computed: {},
  mounted() { },
  methods: {
    handleHowToPlay(data) {
      if (this.isMobile) {
        Bus.$emit("is-open-menu", {
          open: false
        });
      }
      const { type, value, target } = data;
      if (type === "how-to-play") {
        if (value.charAt(0) === "/") {
          this.$router.push(value);
        } else {
          this.$router.push("/play-details?tab=" + value);
        }
      } else if (type === "game-overview") {
        if (!target) {
          this.$router.push("/home" + "#" + value);
        } else {
          this.$router.push("/weapon-cases");
        }
      }
    },
    handleHomeBtnLink(item) {
      this.$router.push("/home" + item.url);
    },
    handlePageRouter(item) {
      if (item.target) {
        this.$router.push("/weapon-cases");
      }
    },
    showDropdownMenu(nameId) {
      const dom = document.querySelector(`#menu-${nameId}`);
      if (!dom) {
        return;
      }
      if (dom.style.display == "block") {
        dom.style.display = "none";
      } else {
        dom.style.display = "block";
      }
      document.querySelectorAll(".dropdown-menu").forEach(item => {
        if (item != dom) {
          item.style.display = "none"
        }
      });
    }
  },
  watch: {
    $route: {
      handler() {
        this.updateKey++;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>